import { Component, OnInit, AfterViewChecked, HostListener } from '@angular/core';
import {LoginService} from '../../service/login.service';
import {User} from '../../../shared/model/user';
import {Router} from '@angular/router';
import {HttpError} from '../../../shared/error/http-error';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { ToastService } from '../../../shared/service/toast.service';

declare var Materialize: any;

@Component({
  selector: 'tx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewChecked {
  user: User;
  errorMessage: string;

  constructor(private loginService: LoginService,
              private router: Router,
              private _toastService: ToastService) {
    this.user = new User();
  }

  ngOnInit() {
    this.loginService.login$
      .subscribe(() => this.router.navigate(['']));

    this.loginService.error$
      .subscribe(loginError => {
        this.showMessage('Usuário ou senha incorretos.');
      });
  }

  ngAfterViewChecked() {
    try {
      Materialize.updateTextFields();
    } catch (e) { }
  }

  @HostListener('keyup.enter') login() {
    this.loginService.login(this.user);
  }

  showMessage(error) {
    this._toastService.showMessage(error, 4000);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/login/component/login/login.component.ts